import { notify } from "./toastNotification";

export const errorHandler = (
  error,
  customMessage = "An error occured",
  useCustomMessage = false
) => {
  if (error?.response?.data?.errors) {
    let {
      response: {
        data: { errors },
      },
    } = error;

    let arrayOfErrors = Object.values(errors);

    if (arrayOfErrors[0] && Array.isArray(arrayOfErrors[0])) {
      arrayOfErrors = arrayOfErrors.flat();
    } else if (arrayOfErrors[0] && typeof arrayOfErrors[0] === "object") {
      arrayOfErrors = arrayOfErrors[0]?.errors
        ?.flat()
        .map((errMsg) => `Row ${arrayOfErrors[0].row}: ${errMsg}`);
    }

    arrayOfErrors.forEach((errorMsg) => {
      console.error("ErrorHandler Array of errors", errorMsg);
      notify(errorMsg, { type: "error" });
    });
  } else {
    const message = useCustomMessage
      ? customMessage
      : error.response?.data?.message ??
        error.response?.data?.error ??
        error?.error?.data?.error ??
        error?.error?.data?.message ??
        error?.error?.error ??
        error?.message ??
        error?.error ??
        customMessage;
    console.error("ErrorHandler", message);
    notify(message, { type: "error" });
  }
};
